import { render, staticRenderFns } from "./Payment.List.vue?vue&type=template&id=5141ca84&"
import script from "./Payment.List.vue?vue&type=script&lang=js&"
export * from "./Payment.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports